// Update this value manually when you want the app version label to change.
export const APP_VERSION = "2026.09.27.01";
export const APP_VERSION_LABEL = `V ${APP_VERSION}`;
export const VERSION_CHECK_PATH = "/version";

export function normalizeAppVersion(value) {
  return value === undefined || value === null ? "" : String(value).trim().replace(/^v/i, "").trim();
}

export function parseAppVersionResponse(rawVersionResponse) {
  const rawValue = String(rawVersionResponse || "").trim();
  if (!rawValue || rawValue.startsWith("<")) {
    return "";
  }

  try {
    const parsed = JSON.parse(rawValue);
    return normalizeAppVersion(parsed.version || parsed.APP_VERSION || parsed.appVersion);
  } catch (error) {
    return normalizeAppVersion(rawValue);
  }
}

export async function fetchLatestAppVersion() {
  const versionUrl = new URL(VERSION_CHECK_PATH, window.location.origin);
  versionUrl.searchParams.set("t", Date.now());

  const response = await fetch(versionUrl.toString(), {
    cache: "no-store",
    headers: {
      Accept: "application/json, text/plain, */*"
    }
  });

  if (!response.ok) {
    throw new Error(`Version check failed with status ${response.status}`);
  }

  return parseAppVersionResponse(await response.text());
}
